function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.2988 44.2446C33.2988 44.2446 33.6577 45.3212 36.3493 46.039C39.0408 46.7567 44.0651 44.6035 47.1156 41.0147C50.166 37.4259 50.7043 33.8372 50.3454 31.6839C49.9866 29.5307 48.9099 27.5568 47.1156 27.0185C45.3212 26.4802 42.6296 25.7625 40.2969 27.7363C37.9642 29.7101 37.5163 31.2346 37.5163 31.2346",
  stroke: "#F88A2B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.2184 25.2241C44.4728 18.7299 36.7369 14.755 31.1456 19.4821C31.2777 19.3701 29.4216 17.626 29.3024 17.5313C27.8195 16.3513 26.8391 15.6249 24.416 15.355C21.466 15.0263 18.0466 15.4455 14.2784 18.0466C12.0175 19.6084 11.4462 21.7875 9.25415 23.2503C7.10089 24.6858 3.16331 27.2453 4.29448 31.2748C4.65192 32.5466 5.97546 33.4826 6.74202 34.5549C6.1147 33.6764 4.10356 35.9316 4.07198 36.668C4.00308 38.191 5.6697 38.9404 6.74202 39.5792L1 44.7829L4.58876 48.5511C4.58876 48.5511 12.3046 42.6296 14.099 42.4502C15.8934 42.2707 18.2261 43.5268 20.0204 44.9623C22.7278 47.1271 25.8199 48.1319 29.1589 46.5471C32.0945 45.1547 35.0947 42.12 32.0299 39.1514C30.6116 37.7762 27.6257 37.7245 25.7625 37.6054",
  stroke: "#F88A2B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.0166 11.7663L39.5792 4.22989",
  stroke: "#F88A2B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.8652 11.5868L25.0447 1",
  stroke: "#F88A2B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.0992 12.3046L8.89551 3.3327",
  stroke: "#F88A2B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.577 30.1285C14.577 30.1285 14.099 26.1809 12.6635 25.344C11.228 24.5057 10.2705 24.1468 8.95557 24.3865",
  stroke: "#F88A2B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.1135 24.9851C22.1135 24.9851 19.722 21.995 17.2098 22.1141C15.638 22.1888 14.0991 22.951 13.3813 24.1482",
  stroke: "#F88A2B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.0186 24.1475C27.0186 24.1475 29.8896 26.7788 29.8896 28.6937C29.8896 30.6073 29.5307 31.0853 29.5307 31.0853",
  stroke: "#F88A2B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.9941 37.3061C21.9941 37.3061 22.831 34.1953 24.746 32.9996C26.6595 31.8038 28.9319 31.2052 28.9319 31.2052",
  stroke: "#F88A2B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.7849 37.0671C37.7849 37.0671 35.9489 34.1874 33.8373 33.0003C31.9238 31.9236 29.7705 31.6839 29.7705 31.6839",
  stroke: "#F88A2B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default __webpack_public_path__ + "media/result-brain-icon.14c913fa.svg";
export { SvgComponent as ReactComponent };